import React, { Component } from 'react'
import { graphql, withApollo, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import gql from 'graphql-tag'

import PropTypes from 'prop-types'

import { changeAuthDetails } from '../../libs/authService'
import {validateRequired} from '../../libs/validation';
import Loader from "../UI/Loader";
import {Form, TextInput, SelectInput} from '../UI'
import queries from './../../graphql/TripPlanner'
import UPDATE_ORDERING_USER from './../../graphql/UpdateOrderingUserDetails.graphql'
  
class OrderingUserDetails extends Component {
    static propTypes = {
      data: PropTypes.object,
      user: PropTypes.object,
    }

  constructor() {
    super()
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      phone: ''
    }
  }

componentWillReceiveProps(next) {
    if (!next.customizedPlan.loading) {
        this.setState(
            next.customizedPlan.customizedplan[0].orderingUser.userProfile
        )
    }
}

handleSubmit = async (values) => {
    this.setState({
        saving: true
        });

    this.props.updateOrderingUser({
        variables: {
            id: this.props.customizedPlan.CustomizedPlan.orderingUser.userProfile.id,
            email: values.email,
            firstName: values.firstName,
            lastName: values.lastName,
            phone: values.phone,
        }
    })
    .then( (response) => {
        // Update in auth0
        changeAuthDetails(this.props.customizedPlan.CustomizedPlan.orderingUser.auth0UserId, values.email, values.phone)

        this.setState({
            saving: false
        });
        this.props.history.push(`/my-plans`)
    })
}


  render() {
    const { t } = this.props

    if (this.props.loading || this.props.customizedPlan.loading) {
      return <Loader showLoader={true} />
    }
    if (!this.props.user.plannerProfile || !this.props.user.plannerProfile.allowPrepaidTrips) {
      this.props.redirect()
    }

    let value 

    return (
        <div className="steps-screen__form">
            <div className="steps-screen__form-title">
                {t('prepaid_order_user_details')}
            </div>
            <div className="steps-screen__form-subtitle">
                {t("prepaid_user_update")}
            </div>
            <Form
                onSubmit={this.handleSubmit}
                submitBtnClassname="btn btn-lg btn-primary btn-danger"
                submitBtnName={t('main:save_continue')}
                >
                <div className="row">
                    <div className="form-group clearfix">
                        <div className="col-md-9">
                            <TextInput
                                id="firstName"
                                placeholder="John"
                                maxChars={50}
                                validationFuncs={[validateRequired]}
                                extraClass=""
                                initialValue={this.state.firstName}
                                label={t('main:first_name')}/>
                        </div>
                    </div>

                    <div className="form-group clearfix">
                        <div className="col-md-9">
                            <TextInput
                            id="lastName"
                            placeholder="Doe"
                            maxChars={50}
                            validationFuncs={[validateRequired]}
                            label={t('main:last_name')}
                            initialValue={this.state.lastName}
                            labelClass="steps-screen__form-input-label"
                            />
                        </div>
                    </div>

                    <div className="form-group clearfix">
                        <div className="col-md-9">
                            <TextInput
                            id="email"
                            maxChars={50}
                            validationFuncs={[validateRequired]}
                            label={t('main:email')}
                            onBlurExternal={this.loadUserByEmail}
                            initialValue={this.state.email}
                            labelClass="steps-screen__form-input-label"
                            />
                        </div>
                    </div>

                    <div className="form-group clearfix">
                        <div className="col-md-9">
                            <TextInput
                                id="phone"
                                maxChars={50}
                                validationFuncs={[validateRequired]}
                                onBlurExternal={this.loadUserByPhone}
                                label={t('main:phone')}
                                initialValue={this.state.phone}
                                labelClass="steps-screen__form-input-label"/>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    )
  }
}

const enhance = compose (
    translate('my_trips'),
    graphql(queries.GET_CUSTOMIZED_PLAN, {
        name: 'customizedPlan',
        options: props => ({
            variables: {
                id: props.match.params.id
            }
        })
    }),
    graphql(UPDATE_ORDERING_USER, {
        name: 'updateOrderingUser'
    })
)  

export default enhance(withApollo(OrderingUserDetails))



// WEBPACK FOOTER //
// src/components/MyTrips/OrderingUserDetails.js